module.exports = __webpack_public_path__ + "static/media/JumboFAQImage.1912dfd4.png";